import React from 'react'
import PropTypes from 'prop-types'

import PageHeader from './Components/PageHeader'
import EventInfo from './Components/EventInfo'
import NewsFeed from './Components/NewsFeed'
import ReturnButton from './Components/ReturnButton'
import RegistrationForm from './Components/RegistrationForm'

function EventsPage({ data, included, ecommerceNews }) {
  const presentations = data.relationships.eventPresentations.data.map((presentation) => {
    return (included.find(include => include.id === presentation.id))
  })

  return (
    <article className="event-page">
      <PageHeader image={data.attributes.image} title={data.attributes.title} />
      <div className="event-page__content">
        <div className="container-fixed">
          <div className="row">
            <div className="col-12 col-md-6 offset-md-1">
              <EventInfo
                attributes={data.attributes}
                presentations={presentations}
              />
            </div>
            <aside className="col-12 col-md-4 u-text-center">
              <RegistrationForm eventId={data.id} />
              <ReturnButton buttonClassName="event-page__cta-mobile" />
            </aside>
            <div className="col-12 event-page__news">
              <h2 className="heading-36 u-text-center text-bold u-mt0 u-mb0 section-heading">Explore more</h2>
              <NewsFeed news={ecommerceNews} />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}

EventsPage.propTypes = {
  included: PropTypes.array.isRequired,
  ecommerceNews: PropTypes.array.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default EventsPage
